import type { ResidentReportModel } from "../types/resident-report.types";
import { formatReportNumber } from "../utils/report-formatters";

export function MetricsGrid({ metrics }: Pick<ResidentReportModel, "metrics">) {
  const items = [
    ["Programs enrolled", formatReportNumber(metrics.eventsJoined), `Across ${metrics.departments ?? 0} departments`],
    ["Attendance rate", `${metrics.attendanceRate}%`, `${metrics.eventsAttended} of recorded sessions`],
    ["Hours engaged", formatReportNumber(metrics.hoursEngaged), `City avg. ${formatReportNumber(metrics.cityAverageHours)}`],
    ["Active streak", `${metrics.attendanceStreakWeeks} wks`, `Longest: ${metrics.longestAttendanceStreakWeeks} wks`],
    ["Residents referred", formatReportNumber(metrics.residentsReferred ?? 0), "All still active"],
    ["Points", formatReportNumber(metrics.points), `${formatReportNumber(metrics.pointsRedeemed)} redeemed`],
  ] as const;

  return (
    <section className="metrics-grid" aria-label="Resident metrics">
      {items.map(([label, value, detail]) => (
        <article key={label} className="metric-card">
          <p>{label}</p>
          <strong>{value}</strong>
          <span>{detail}</span>
        </article>
      ))}
    </section>
  );
}
